import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';
import { Box } from '@rebass/emotion';
import styled from '@emotion/styled';

import PageTitle from '@app/components/PageTitle';
import Link from '@app/components/Link';
import ErrorBoundary from '@app/components/ErrorBoundary';

import {
  Skeleton,
  SubHeader,
  SubHeaderTitle,
} from '@app/shop/components/Skeleton/Skeleton';
import AuthCheck from '@app/shop/components/AuthCheck';
import messages from './Success.messages';

const SuccessLayout: FC = ({ children }) => {
  const { orderNumber } = useParams<{ orderNumber: string }>();

  return (
    <AuthCheck>
      <Skeleton>
        <PageTitle>{messages.title}</PageTitle>
        <SubHeader>
          <SubHeaderTitle>
            <Link to={`/:language/shop/checkout/success/${orderNumber}`}>
              <FormattedMessage {...messages.title} />
            </Link>
          </SubHeaderTitle>
        </SubHeader>
        <ErrorBoundary>
          <Box p={[20, 40]}>
            <Wrapper>{children}</Wrapper>
          </Box>
        </ErrorBoundary>
      </Skeleton>
    </AuthCheck>
  );
};

const Wrapper = styled.div`
  max-width: 34em;
  margin: 0 auto;
  justify-content: space-between;
`;

export default SuccessLayout;
